import React from "react";
import { Box, Container, Typography, Paper, Grid, Chip } from "@mui/material";
import { useTheme } from "../../../context/ThemeContext";
import { platformFeatures } from "../data";

const FeaturesSection = () => {
  const { theme } = useTheme();

  return (
    <Box id="features" sx={{ bgcolor: "#f8f9fa", py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Chip label="Platform Features" sx={{ bgcolor: theme.lightBg, color: theme.primary, fontWeight: 600, mb: 2 }} />
          <Typography variant="h3" fontWeight={700} sx={{ mb: 2, color: "#1a1a2e" }}>
            Everything You Need
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: "auto" }}>
            A comprehensive suite of tools and features designed to make property rental management effortless.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {platformFeatures.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                sx={{
                  p: 4,
                  textAlign: "center",
                  borderRadius: 3,
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": { transform: "translateY(-8px)", boxShadow: "0 15px 40px rgba(0,0,0,0.1)" },
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 3,
                    bgcolor: `${feature.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 3,
                    color: feature.color,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  {feature.desc}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
